import React, { useEffect, useState } from 'react';
import './AccountSettings.css';
import useBlockCheck from '../../hooks/useBlockCheck'; // Import the hook
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../../api';
import UsersTopbar from '../UsersTopbar/UsersTopbar';
import swal from 'sweetalert';
import { useAuth } from '../../context/AuthContext';

const AccountSettings = () => {
  useBlockCheck('user'); // 🔥 Prevents blocked users from accessing this page
  const navigate = useNavigate();
  const { token } = useAuth();
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // Fetch the user's email
  useEffect(() => {
    const fetchEmail = async () => {
      try {
        const response = await axios.get(api.getProfile, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setEmail(response.data.email);
      } catch (error) {
        console.error('Error fetching email:', error);
        swal('Error', 'Failed to fetch email', 'error');
      }
    };

    fetchEmail();
  }, [token]);

  // Handle password update
  const handlePasswordUpdate = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      swal('Error', 'New password and confirm password do not match', 'error');
      return;
    }

    try {
      await axios.post(
        api.updatePassword,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      swal('Success', 'Password updated successfully', 'success');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      console.error('Error updating password:', error);
      swal('Error', 'Failed to update password', 'error');
    }
  };

  return (
    <div>
      <UsersTopbar />
      <div className="account-settings-container">
        <button 
          className="account-settings-close-button" 
          onClick={() => navigate('/home')}
          aria-label="Close"
        >
        ×
        </button>
        <h1>Manage Your Account</h1>
        <div className="account-settings-options">
          <div className="settings-content">
            <p>
            Here, you can update your account password.
            </p>
            <div className="form-container">
              <form className="account-settings-form" onSubmit={handlePasswordUpdate}>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <div className="email-display">
                    <h6>Your email address is: </h6>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      readOnly
                      placeholder="Your email"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="password">Change Password</label>
                  <input
                    type="password"
                    id="current-password"
                    name="currentPassword"
                    placeholder="Enter current password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                  <input
                    type="password"
                    id="new-password"
                    name="newPassword"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <input
                    type="password"
                    id="confirm-password"
                    name="confirmPassword"
                    placeholder="Re-type password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <div className="settings-form-button-container">
                  <button
                    type="button"
                    className="settings-form-cancel-button"
                    onClick={() => navigate('/home')}
                  >
                  Cancel
                  </button>
                  <button type="submit" className="settings-form-save-button">
                  Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;